import React from 'react';
import { usePromiseTracker } from '../promise-tracker';

import SpinnerSVG from '../icons/SpinnerSVG';

import '../loading-spinner/spinner.css';

function LoadingSpinner() {
  const { promiseInProgress  } = usePromiseTracker();

  return (
    <div>
      {promiseInProgress  === true ? (
        <React.Fragment>
          <div className='spinner-overlay'></div>
          <div
            className="spinner-container fixed z-50 text-center"
            style={{ width: '200px', left: '50%', top: '30%' }}
          >
            <SpinnerSVG
              classes="spinner"
              width="50px"
              height="50px"
              viewbox="0 0 130 130"
            />
            <p id="spinner-message" style={{ marginLeft: '-200px' }}>
              Processing your request
            </p>
          </div>
        </React.Fragment>
      ) : null}
    </div>
  );
}

export default LoadingSpinner;
